<page-load-header *ngIf="!initialized"></page-load-header>

<h3>Change Password</h3>
<div *ngIf="initialized" class="">
  <!-- Content Section -->
  <div class="bg-light">
    <div class="container">
      <div *ngIf="errorMessage" class="alert alert-danger" role="alert">
        {{ errorMessage }}
      </div>
      <form [formGroup]="formGroup" (ngSubmit)="onSave()" novalidate>
        <!-- Input -->
        <div class="js-form-message mb-6">
          <label class="form-label">
            Current password
          </label>

          <div class="form-group">
            <input type="password" class="form-control" name="currentPassword" formControlName="currentPassword" placeholder="Enter your current password" />
            <div class="invalid-message">
              <div>Current password is required</div>
            </div>
          </div>
        </div>
        <!-- End Input -->

        <!-- Input -->
        <div class="mb-6">
          <div class="js-form-message">
            <label class="form-label">
              New password
            </label>

            <div class="form-group">
              <input id="newPassword" type="password" class="form-control" name="newPassword" formControlName="newPassword" placeholder="Enter your password" />
              <div class="invalid-message">
                <div>New password is required</div>
              </div>
            </div>
          </div>
        </div>
        <!-- End Input -->

        <!-- Input -->
        <div class="js-form-message mb-6">
          <label class="form-label">
            Confirm password
          </label>

          <div class="form-group">
            <input type="password" class="form-control" name="confirmNewPassword" placeholder="Confirm your password" formControlName="confirmPassword" />
            <div class="invalid-message">
              <div>Confirm password is required</div>
            </div>
            <div *ngIf="formGroup.hasError('notSame')" class="invalid-message-visible">
              <div>Passwords do not match</div>
            </div>
          </div>
        </div>
        <!-- End Input -->

        <div class="w-lg-50">
          <!-- Buttons -->
          <button type="submit" class="btn btn-sm btn-admin-primary transition-3d-hover mr-1">Save Password</button>
          <button type="button" (click)="cancel()" class="btn btn-sm btn-soft-secondary transition-3d-hover">Cancel</button>
          <!-- End Buttons -->
        </div>
      </form>
    </div>
  </div>
  <!-- End Content Section -->
</div>
